export function checkpriceFormReducer(state, action) {
  switch (action.type) {
    case "SET_CHECKPRICE_FORM":
      return { ...state, checkpriceForm: action.payload }
    case "CLEAR_CHECKPRICE_FORM":
      return { ...state, checkpriceForm: {} }
    case "SET_CHECKPRICE_MODE_DOMESTIC":
      return { ...state, checkpriceMode: 'domestic' }
    case "SET_CHECKPRICE_MODE_INTER":
      return { ...state, checkpriceMode: 'inter' }
    case "SET_CHECKPRICE_MODE_MULTIDEST_DOMESTIC":
      return { ...state, checkpriceMode: 'multidest-domestic' }
    case "CLEAR_CHECKPRICE_MODE":
      return { ...state, checkpriceMode: '' }
    default:
      return state
  }
}